import { getFacets, getResults } from '@elastic/search-ui-site-search-connector/lib/cjs/responseAdapters'

export default function adaptResponse(response, documentType) {
  const results = getResults(response.records, documentType)
  const totalPages = response.info[documentType].num_pages
  const totalResults = response.info[documentType].total_result_count
  const requestId = ''
  const facets = getFacets(response.info[documentType])
  // eslint-disable-next-line no-return-assign, no-param-reassign
  results.map(r => r._meta = {}) // Add _meta or search-ui autocompleteClickHandler explodes
  const updatedResults = results.map((result) => {
    if (result.url && result.url.raw) {
      try {
        const url = new URL(result.url.raw)
        return {
          ...result,
          url: {
            ...result.url,
            raw: url.pathname + url.search + url.hash,
          },
        }
      } catch (error) {
        // ignore invalid urls
      }
    }
    return result
  })
  return {
    rawResponse: response,
    results: updatedResults,
    totalPages,
    totalResults,
    requestId,
    ...(Object.keys(facets).length > 0 && { facets }),
  }
}
